import React from 'react';
import { List, ListItemButton, ListItemIcon, ListItemText, Collapse, Divider } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ArticleIcon from '@mui/icons-material/Article';
import SwipeLeftIcon from '@mui/icons-material/SwipeLeft';
import CommentIcon from '@mui/icons-material/Comment';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useHistory } from 'react-router-dom';

const WorkshopNav = ({ permissions, currentPath, openWorkShopMenu, handleClickWorkShopMenu, openWorkShopEventManagemant, handleClickopenWorkShopEventManagemant, openWorkShopParticpant, handleClickWorkShopParticpant, openWorkShopSetting, handleClickWorkShopSetting, openClickWorkShopUser, handleClickWorkShopUser }) => {
    const history = useHistory();

    return (
        <div>
            {currentPath !== '/admin/events' && (
                <>
                    <Divider sx={{ my: 1 }} />
                    <Divider sx={{ my: 1 }} />
                    <ListItemButton onClick={handleClickWorkShopMenu} sx={{ color: '#1976d2' }}>
                        <ListItemIcon sx={{ color: '#1976d2' }}>
                            <DashboardIcon onClick={() => history.push('/admin/workshop/dashbord')} />
                        </ListItemIcon>
                        <ListItemText primary="WorkShop MS" sx={{ color: '#1976d2' }} />
                        {openWorkShopMenu ? <ExpandLess /> : <ExpandMore sx={{ color: '#1976d2' }} />}
                    </ListItemButton>
                </>
            )}
            <Collapse in={openWorkShopMenu} timeout="auto" unmountOnExit>
                {currentPath !== '/admin/events' && (
                    <List component="div" disablePadding>
                        <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/workshop/dashbord')}>
                            <ListItemIcon sx={{ color: '#1976d2' }}>
                                <DashboardIcon onClick={() => history.push('/admin/workshop/dashbord')} />
                            </ListItemIcon>
                            <ListItemText primary="WorkShop Dashbord" />
                        </ListItemButton>
                        <Divider sx={{ my: 1 }} />
                        <Divider sx={{ my: 1 }} />
                        {permissions['p_workshop-collection'] && (
                            <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/workshop/collections')}>
                                <ListItemIcon sx={{ color: '#1976d2' }}>
                                    <DashboardIcon onClick={() => history.push('/admin/workshop/collections')} />
                                </ListItemIcon>
                                <ListItemText primary="W-Collections" />
                            </ListItemButton>
                        )}
                        <Divider sx={{ my: 1 }} />
                        
                        {permissions['p_workshop-category-list'] && (
                            <ListItemButton onClick={handleClickopenWorkShopEventManagemant} sx={{ color: '#1976d2' }}>
                                <ListItemIcon sx={{ color: '#1976d2' }}>
                                    <ArticleIcon />
                                </ListItemIcon>
                                <ListItemText primary="W-Management" sx={{ color: '#1976d2' }} />
                                {openWorkShopEventManagemant ? <ExpandLess /> : <ExpandMore sx={{ color: '#1976d2' }} />}
                            </ListItemButton>
                        )}
                        <Collapse in={openWorkShopEventManagemant} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {permissions['p_workshop-category-list'] && (
                                    <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/workshop/category')}>
                                        <ListItemIcon sx={{ color: '#1976d2' }}>
                                            <SwipeLeftIcon onClick={() => history.push('/admin/workshop/category')} />
                                        </ListItemIcon>
                                        <ListItemText primary="WorkShop Category" />
                                    </ListItemButton>
                                )}
                                {permissions['p_workshop-manage-workshop-list'] && (
                                    <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/workshop/manage')}>
                                        <ListItemIcon sx={{ color: '#1976d2' }}>
                                            <SwipeLeftIcon onClick={() => history.push('/admin/workshop/manage')} />
                                        </ListItemIcon>
                                        <ListItemText primary="Manage Workshop" />
                                    </ListItemButton>
                                )}
                                {permissions['p_workshop-manage-session-list'] && (
                                    <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/workshop/manage-session')}>
                                        <ListItemIcon sx={{ color: '#1976d2' }}>
                                            <SwipeLeftIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Manage Session" />
                                    </ListItemButton>
                                )}
                                <Divider sx={{ my: 1 }} />
                            </List>
                        </Collapse>
                        <Divider sx={{ my: 1 }} />
                        {permissions['p_workshop-participant-list'] && (
                            <ListItemButton onClick={handleClickWorkShopParticpant} sx={{ color: '#1976d2' }}>
                                <ListItemIcon sx={{ color: '#1976d2' }}>
                                    <ArticleIcon />
                                </ListItemIcon>
                                <ListItemText primary="Participant" sx={{ color: '#1976d2' }} />
                                {openWorkShopParticpant ? <ExpandLess /> : <ExpandMore sx={{ color: '#1976d2' }} />}
                            </ListItemButton>
                        )}
                        <Collapse in={openWorkShopParticpant} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {permissions['p_workshop-participant-list'] && (
                                    <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/workshop/manage-particpant')}>
                                        <ListItemIcon sx={{ color: '#1976d2' }}>
                                            <GroupAddIcon onClick={() => history.push('/admin/workshop/manage-particpant')} />
                                        </ListItemIcon>
                                        <ListItemText primary="Manage Participant" />
                                    </ListItemButton>
                                )}
                                {permissions['p_workshop-order-list'] && (
                                    <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/workshop/manage-particpant-order')}>
                                        <ListItemIcon sx={{ color: '#1976d2' }}>
                                            <GroupAddIcon onClick={() => history.push('/admin/workshop/manage-particpant-order')} />
                                        </ListItemIcon>
                                        <ListItemText primary="Orders" />
                                    </ListItemButton>
                                )}
                                {permissions['p_workshop-memeber-statistics-list'] && (
                                    <ListItemButton sx={{ pl: 4 }}>
                                        <ListItemIcon sx={{ color: '#1976d2' }}>
                                            <GroupAddIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Members Statistics" />
                                    </ListItemButton>
                                )}
                                {permissions['p_workshop-invitation-list'] && (
                                    <ListItemButton sx={{ pl: 4 }}>
                                        <ListItemIcon sx={{ color: '#1976d2' }}>
                                            <GroupAddIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Invitations" />
                                    </ListItemButton>
                                )}
                                <Divider sx={{ my: 1 }} />
                            </List>
                        </Collapse>
                        <Divider sx={{ my: 1 }} />
                        {permissions['p_workshop-coupons-list'] && (
                            <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/workshop/manage-coupon')}>
                                <ListItemIcon sx={{ color: '#1976d2' }}>
                                    <CommentIcon onClick={() => history.push('/admin/workshop/manage-coupon')} />
                                </ListItemIcon>
                                <ListItemText primary="Coupon" />
                            </ListItemButton>
                        )}
                        <Divider sx={{ my: 1 }} />
                        {permissions['p_workshop-event-certificate-list'] && (
                            <ListItemButton sx={{ pl: 4 }}>
                                <ListItemIcon sx={{ color: '#1976d2' }}>
                                    <CommentIcon />
                                </ListItemIcon>
                                <ListItemText primary="Event Certificate" />
                            </ListItemButton>
                        )}
                        <Divider sx={{ my: 1 }} />
                        <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon sx={{ color: '#1976d2' }}>
                                <CommentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Logs" />
                        </ListItemButton>
                        <Divider sx={{ my: 1 }} />
                        <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/workshop/reports')}>
                            <ListItemIcon sx={{ color: '#1976d2' }}>
                                <CommentIcon onClick={() => history.push('/admin/workshop/reports')} />
                            </ListItemIcon>
                            <ListItemText primary="Workshop Report" />
                        </ListItemButton>
                        <Divider sx={{ my: 1 }} />
                        {permissions['p_workshop-user-manage-list'] && (
                            <ListItemButton onClick={handleClickWorkShopUser} sx={{ color: '#1976d2' }}>
                                <ListItemIcon sx={{ color: '#1976d2' }}>
                                    <ArticleIcon />
                                </ListItemIcon>
                                <ListItemText primary="Users" sx={{ color: '#1976d2' }} />
                                {openClickWorkShopUser ? <ExpandLess /> : <ExpandMore sx={{ color: '#1976d2' }} />}
                            </ListItemButton>
                        )}
                        <Collapse in={openClickWorkShopUser} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {permissions['p_workshop-user-manage-list'] && (
                                    <ListItemButton sx={{ pl: 4 }} onClick={() => history.push('/admin/workshop/manage-user')}>
                                        <ListItemIcon sx={{ color: '#1976d2' }}>
                                            <GroupAddIcon onClick={() => history.push('/admin/workshop/manage-user')} />
                                        </ListItemIcon>
                                        <ListItemText primary="Manage User" />
                                    </ListItemButton>
                                )}
                                <Divider sx={{ my: 1 }} />
                            </List>
                        </Collapse>
                    </List>
                )}

                {currentPath !== '/admin/events' && (
                    <ListItemButton onClick={handleClickWorkShopSetting} sx={{ color: '#1976d2' }}>
                        <ListItemIcon sx={{ color: '#1976d2' }}>
                            <AppSettingsAltIcon />
                        </ListItemIcon>
                        <ListItemText primary="Setting" sx={{ color: '#1976d2' }} />
                        {openWorkShopSetting ? <ExpandLess /> : <ExpandMore sx={{ color: '#1976d2' }} />}
                    </ListItemButton>
                )}
                <Collapse in={openWorkShopSetting} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon sx={{ color: '#1976d2' }}>
                                <ContactPageIcon onClick={() => history.push('/admin/exhibition/exhibitor-profile')} />
                            </ListItemIcon>
                            <ListItemText primary="Profile" onClick={() => history.push('/admin/exhibition/exhibitor-profile')} />
                        </ListItemButton>
                        {permissions['p_conference-bage'] && (
                            <ListItemButton sx={{ pl: 4 }}>
                                <ListItemIcon sx={{ color: '#1976d2' }}>
                                    <ContactPageIcon />
                                </ListItemIcon>
                                <ListItemText primary="BackUp" />
                            </ListItemButton>
                        )}
                        {permissions['p_exhibition-guest-badge-design-list'] && (
                            <ListItemButton sx={{ pl: 4 }}>
                                <ListItemIcon sx={{ color: '#1976d2' }}>
                                    <ContactPageIcon />
                                </ListItemIcon>
                                <ListItemText primary="Master Category" />
                            </ListItemButton>
                        )}
                        {permissions['p_event-email-template'] && (
                            <ListItemButton sx={{ pl: 4 }}>
                                <ListItemIcon sx={{ color: '#1976d2' }}>
                                    <ContactPageIcon onClick={() => history.push('/admin/workshop/index-email')} />
                                </ListItemIcon>
                                <ListItemText primary="Email Template" onClick={() => history.push('/admin/workshop/index-email')} />
                            </ListItemButton>
                        )}
                    </List>
                </Collapse>
            </Collapse>
            <Divider sx={{ my: 1 }} />

        </div>
    );
};

export default WorkshopNav;